import script from "./update-banner.vue?vue&type=script&setup=true&lang=js"
export * from "./update-banner.vue?vue&type=script&setup=true&lang=js"

import "./update-banner.vue?vue&type=style&index=0&id=0ef5ccd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ef5ccd6"]])

export default __exports__